import dayjs from "dayjs";
import mySqlToLocal from "./mySqlToLocal";

const isToday = (date) => {
  if (!date) {
    return false;
  }

  if (typeof date === 'string') {
    date = mySqlToLocal(date);
  }

  return dayjs(date).isSame(dayjs(), 'day');
}

export default isToday